export const GOOGLE_SIGN_IN_START_FAILURE =
    "Google sign-in could not start. Please try again.";

export type GoogleSignInStartStatus = "idle" | "pending" | "failed";

export async function startGoogleSignInWith(
    signIn: (callbackURL: string) => Promise<void>,
    callbackURL: string,
    report: (status: GoogleSignInStartStatus) => void,
): Promise<void> {
    report("pending");
    try {
        await signIn(callbackURL);
    } catch {
        report("failed");
    }
}
